import React from 'react';
import styles from './Container.module.sass';

export const Container = ({children, isSmall}: any) => 
    <div className={`${styles.container} ${isSmall ? styles.small : ''}`}>
        {children}
    </div>;